import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PretendardText from "../pretendardText";

const DetailFormText = (props) => {
  return <DetailFormTextWrapper {...props} />;
};

export default DetailFormText;

const DetailFormTextWrapper = styled(PretendardText).attrs((props) => {})`
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  color: #aaa;
  max-width: 872px;
  white-space: pre-wrap;
`;
